import { Component } from '@angular/core';

@Component({
    selector: 'backend-license-modal',
    templateUrl: './license-modal.component.html',
    styleUrls: ['./license-modal.component.css'],
    standalone: false
})
export class LicenseModalComponent {
  public open = false;

  closeModal(){
    this.open = false;
  }
}
